import { api } from "@/lib/api";

// Convert VAPID public key from base64url string to Uint8Array required by browser
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const output = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; ++i) output[i] = raw.charCodeAt(i);
  return output;
}

let cachedPublicKey = null;

async function getPublicKey() {
  if (cachedPublicKey) return cachedPublicKey;
  const { data } = await api.get("/push/public-key");
  cachedPublicKey = data?.public_key || null;
  return cachedPublicKey;
}

export function pushSupported() {
  return (
    typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window
  );
}

/** Register SW, request permission, subscribe, and send to backend. */
export async function enablePush(guestId) {
  if (!pushSupported()) return { ok: false, reason: "unsupported" };
  try {
    // Register (or reuse) service worker
    const reg = await navigator.serviceWorker.register("/sw.js");
    await navigator.serviceWorker.ready;

    // Permission
    let perm = Notification.permission;
    if (perm === "default") perm = await Notification.requestPermission();
    if (perm !== "granted") return { ok: false, reason: perm };

    // Existing subscription?
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      const publicKey = await getPublicKey();
      if (!publicKey) return { ok: false, reason: "no-public-key" };
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(publicKey),
      });
    }

    const json = sub.toJSON();
    await api.post(`/push/subscribe/${guestId}`, {
      endpoint: json.endpoint,
      keys: json.keys || {},
    });
    return { ok: true };
  } catch (e) {
    console.warn("Push enable failed", e);
    return { ok: false, reason: e?.message || "error" };
  }
}
